export default "__VITE_ASSET__D$gzsYTr__"